import { Autocomplete, FormControl, FormHelperText, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

function BaseAutoCompletes(props) {
	return <Autocomplete {...props} />;
}

export const SxTextField = (err, isMultiple = false) => {
	return {
		width: '100%',
		'& > div': {
			padding: '0px 6px 0px 6px !important',
			outline: 'none',
		},
		'& > .MuiInputLabel-root': { top: isMultiple ? '0px' : '-8px' },
		'& > .MuiInputBase-root': { padding: isMultiple ? '8px 4px !important' : '0px 6px 0px 6px!important' },
		'& > .Mui-focused': { top: 0 },
		'& > .MuiFormLabel-filled': { top: 0 },
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: err && 'var(--error)',
			borderWidth: err && 1,
		},
	};
};

function accessNestedObject(path, obj) {
	return path.split('.').reduce((prev, curr) => {
		return prev ? prev[curr] : null;
	}, obj || null);
}

const getOptionLabel = (option, optionLabel) => {
	let optLabel = option && (optionLabel ? `${option[optionLabel]}` : option);
	if (optionLabel && Array.isArray(optionLabel)) {
		optLabel = accessNestedObject(optionLabel.join('.'), option);
	}
	return optLabel;
};

export default function BaseAutocomplete({
	control,
	name,
	label,
	errors,
	optionLabel,
	optionId,
	callback,
	config = { styles: '', classes: 'w-full', multiple: false, disabled: false, inputProps: {} },
	options,
	...props
}) {
	//* otherSetting should be put on CONFIG props as ONE object ex: styles
	const { styles, classes, multiple, disabled, inputProps } = config;

	const errText = `${name} is required `;
	const isError = errors?.name || errors[name] || '';
	const errMsg = errors.name?.message || errors[name]?.message;
	return (
		<FormControl sx={styles} className={[classes].join(' ')}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, value } }) => {
					return (
						<>
							<BaseAutoCompletes
								multiple={multiple}
								disabled={disabled}
								name={name}
								options={options}
								getOptionLabel={(option) => getOptionLabel(option, optionLabel)}
								isOptionEqualToValue={(option, newValue) => option[optionId || 'id'] === newValue[optionId || 'id']}
								onChange={(event, dataOption) => {
									onChange(dataOption);
									if (callback && typeof callback === 'function') {
										callback(event, dataOption);
									}
								}}
								value={value || ''}
								error={isError}
								renderInput={(params) => (
									<TextField
										{...params}
										label={label}
										sx={() => SxTextField(!!isError, !!multiple)}
										inputProps={{
											...params.inputProps,
											autoComplete: 'new-password',
										}}
										{...inputProps}
									/>
								)}
								className='bg-white'
								{...props}
							/>
							{isError && <FormHelperText className='!text-red-600'>{errMsg ? errMsg : errText}</FormHelperText>}
						</>
					);
				}}
			/>
		</FormControl>
	);
}
